import { css } from '@linaria/core';
import { breakpoints } from 'styles/utils';
export const extraMargin = "odules__Featured__styles_ts-extraMargin-e1saywe3";
export const wrapper = "odules__Featured__styles_ts-wrapper-wl367wv";
export const navbarWrapper = "odules__Featured__styles_ts-navbarWrapper-nyui8w1";
export const newNavbarWrapper = "odules__Featured__styles_ts-newNavbarWrapper-n10dlcbh";
export const newFooter = "odules__Featured__styles_ts-newFooter-n1gyh6f8";

require("./styles.linaria.module.css!=!../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./styles.ts");